export default __webpack_public_path__ + "static/media/bicicletero2.ad01ec07.svg";